import SearchInput from './search';

export default SearchInput;
